import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function LatestSection() {
  const latestComics = comics.slice(0, 8);

  return (
    <section className="py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <span className="text-xs font-semibold text-accent-500 uppercase tracking-wider">Latest Updates</span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mt-1 font-heading">
              <strong>最近更新</strong>
            </h2>
            <p className="text-sm text-foreground-500 mt-2">每日更新最新章节，追更不停歇</p>
          </div>
          <Link
            to="/category/all"
            className="hidden md:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap font-medium"
          >
            全部漫画 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop>
          {latestComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
        <Link
          to="/category/all"
          className="md:hidden flex items-center justify-center gap-1 text-sm text-primary-500 mt-6 font-medium"
        >
          全部漫画 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}